import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-nav-home-student',
  templateUrl: './nav-home-student.component.html',
  styleUrls: ['./nav-home-student.component.css']
})
export class NavHomeStudentComponent implements OnInit {
  @Input() learner:any={}
  @Input() linkId:number=0
  @Input()  quiz_mode_name="standard"
  constructor() { }

  ngOnInit(): void {
  }

}
